/**
 * c-card-atc.js
 *
 * Shared add-to-cart behaviour for the `c-product-card` snippet. Cards render
 * a plain product form that posts to the cart, so everything still works
 * without JavaScript; this script upgrades the submit to an AJAX add that
 * refreshes and opens the cart drawer instead of navigating away.
 *
 * Installs a single delegated listener no matter how many sections load it.
 */
(function () {
  if (window.__cCardAtcReady) return;
  window.__cCardAtcReady = true;

  function openCartDrawer() {
    var toggle = document.querySelector(
      '.fm-cart-btn, [data-cart-drawer-toggle], cart-drawer-component [aria-controls]'
    );
    if (toggle && toggle.tagName !== 'A') {
      toggle.click();
      return true;
    }
    return false;
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-c-card-atc]');
    if (!form) return;
    event.preventDefault();

    var button = form.querySelector('[data-c-card-atc-btn]');
    var restore = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = button.getAttribute('data-adding-label') || restore;
    }

    fetch(form.getAttribute('action') + '.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (button) {
          button.disabled = false;
          button.textContent = result.ok
            ? restore
            : (result.data && result.data.description) || restore;
        }
        if (result.ok) {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (!openCartDrawer()) {
            window.location.href = form.getAttribute('data-cart-url') || '/cart';
          }
        }
      })
      .catch(function () {
        if (button) {
          button.disabled = false;
          button.textContent = restore;
        }
        /* Fall back to the non-AJAX flow rather than failing silently. */
        form.submit();
      });
  });
})();
